export default __webpack_public_path__ + "static/media/price-check-icon.a5573181.svg";